import { BTIconTextStrikethrough } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";
import { isSelectionExclusivelyInTitle } from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "strike";
const friendlyName = "Strikethrough";
const icon = <BTIconTextStrikethrough />;
const onClick = (editor: IEditor) => {
    return editor.tiptapEditor.chain().focus().toggleStrike().run();
};

export const strikethroughControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>, editor: IEditor) {
        return (
            supportedExtensions.has(extensionId) && editor.editorState.mode !== "inlineControlsOnly"
        );
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            tiptapEditor.can().chain().focus().toggleStrike().run() &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="strikethroughControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                key={this.key}
                menuProps={{
                    testid: this.key,
                    onClick: () => onClick(editor),
                    icon,
                    disabled: !this.isControlEnabled(editor),
                    className: "btEditorControlBarMenuItem",
                }}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default strikethroughControl;
